import { Button, CircularProgress, Typography } from '@mui/material';

export const SecondaryButton = (props = {}) => {
  const { sx, children, disabled, onClick, ...otherProps } = props;

  return (
    <Button
      variant="contained"
      onClick={(e) => {
        if (onClick) {
          if (props.loadingLogic) {
            onClick(e);
          } else {
            onClick(e);
          }
        }
      }}
      {...otherProps}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '15px',
        gap: '10px',
        position: 'relative',
        width: '100%',
        height: '48px',
        minHeight: '48px',
        borderRadius: '64px',
        backgroundColor: disabled ? '#9CA0AB' : 'rgba(248, 248, 248, 0.82)',
        boxShadow: 'none',
        ...(disabled || props.isLoading ? { pointerEvents: 'none' } : {}),
        '&.MuiButtonBase-root:hover': {
          bgcolor: 'rgba(248, 248, 248, 1)',
          boxShadow: 'none',
        },
        border: 'none',

        textTransform: 'uppercase',
        ...props.sx,
      }}
      style={{ textTransform: 'none', ...props.style }}
    >
      <Typography
        variant="button"
        sx={{
          color: '#44546A',
          fontWeight: '700',
          fontSize: '16px',
          whiteSpace: 'nowrap',
        }}
      >
        {props.isLoading ? (
          <CircularProgress
            color="inherit"
            size={'25px'}
            sx={{
              position: 'absolute',
              margin: 'auto',
              top: 0,
              bottom: 0,
              insetInlineStart: 0,
              insetInlineEnd: 0,
            }}
          />
        ) : (
          <>{props.children}</>
        )}
      </Typography>
    </Button>
  );
};

export default SecondaryButton;
